import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FaShare } from 'react-icons/fa';
import './App.css';
import TotalResult from "./components/TotalResult";
import NavigationWithPopups from "./components/NavigationWithPopups";
import MapView from "./components/MapView";
import PartyResults from "./components/PartyResults";
import ElectionSlider from "./components/ElectionSlider";
import ConstituencyWise from "./components/ConstituencyWise";
import RegionWiseResults from "./components/RegionWiseResults";
import HeaderWithClose from "./components/HeaderWithClose";

function App() {
  const [showShareModal, setShowShareModal] = useState(false);
  const [showComponent, setShowComponent] = useState(null);
  const [searchParams] = useSearchParams();

  const sharePath = `https://results.mathrubhumi.com/result/bihar-poll-25-en?show=results`;
  const encodedUrl = encodeURIComponent(sharePath);
  const shareText = encodeURIComponent('Check out Bihar election Results 2025 | Mathrubhumi');

  const socialLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&t=${shareText}`,
    twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${shareText}`,
    whatsapp: `https://api.whatsapp.com/send?text=${shareText}%20${encodedUrl}`
  };

  useEffect(() => {
    const component = searchParams.get('show');
    if (['constituency', 'region', 'results'].includes(component)) {
      setShowComponent(component);
    }
  }, [searchParams]);

  const handleShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: 'Bihar Election 2025 Results',
          text: 'Check out the latest election results',
          url: sharePath,
        });
      } else {
        setShowShareModal(true);
      }
    } catch (err) {
      if (err.name !== 'AbortError') {
        setShowShareModal(true);
      }
    }
  };

  const handleSocialShare = (e) => {
    e.preventDefault();
    const url = e.currentTarget.href;
    setShowShareModal(false);
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(sharePath);
      alert('Link copied to clipboard!');
      setShowShareModal(false);
    } catch (err) {
      console.error('Failed to copy:', err);
      alert('Failed to copy link. Please try again.');
    }
  };

  const renderShareModal = () => (
    <div className="share-modal-overlay" onClick={() => setShowShareModal(false)}>
      <div className="share-modal" onClick={e => e.stopPropagation()}>
        <h3>Share Bihar Total Results via</h3>
        <div className="social-icons">
          <a href={socialLinks.facebook} onClick={handleSocialShare} target="_blank" rel="noopener noreferrer">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 25" fill="none">
              <path d="M23.9999 12.9675C23.9999 6.34349 18.6239 0.967491 11.9999 0.967491C5.37594 0.967491 -6.10352e-05 6.34349 -6.10352e-05 12.9675C-6.10352e-05 18.7755 4.12794 23.6115 9.59994 24.7275V16.5675H7.19994V12.9675H9.59994V9.96749C9.59994 7.65149 11.4839 5.76749 13.7999 5.76749H16.7999V9.36749H14.3999C13.7399 9.36749 13.1999 9.90749 13.1999 10.5675V12.9675H16.7999V16.5675H13.1999V24.9075C19.2599 24.3075 23.9999 19.1955 23.9999 12.9675Z" fill="#121212"/>
            </svg>
          </a>
          <a href={socialLinks.twitter} onClick={handleSocialShare} target="_blank" rel="noopener noreferrer">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 22" fill="none">
              <path d="M18.9014 0.250824H22.5815L14.5414 9.44006L23.9999 21.9447H16.5929L10.7923 14.3607L4.15513 21.9447H0.472751L9.0724 12.1157L-6.10352e-05 0.250824H7.59276L12.836 7.18283L18.9014 0.250824ZM17.6097 19.7418H19.649L6.48582 2.33788H4.29753L17.6097 19.7418Z" fill="#121212"/>
            </svg>
          </a>
          <a href={socialLinks.whatsapp} onClick={handleSocialShare} target="_blank" rel="noopener noreferrer">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M20.4601 3.49197C19.3599 2.38068 18.0495 1.49958 16.6053 0.900037C15.161 0.300495 13.6119 -0.00546804 12.0481 -2.00585e-05C5.49616 -2.00585e-05 0.15618 5.33996 0.15618 11.8919C0.15618 13.9919 0.708179 16.0319 1.74018 17.8319L0.0601807 23.9999L6.36016 22.3439C8.10016 23.2919 10.0561 23.7959 12.0481 23.7959C18.6001 23.7959 23.9402 18.4559 23.9402 11.9039C23.9402 8.72395 22.7041 5.73596 20.4601 3.49197ZM12.0481 21.7799C10.2721 21.7799 8.53216 21.2999 7.00816 20.3999L6.64816 20.1839L2.90417 21.1679L3.90017 17.5199L3.66017 17.1479C2.67347 15.5723 2.14954 13.751 2.14817 11.8919C2.14817 6.44396 6.58816 2.00397 12.0361 2.00397C14.6761 2.00397 17.1601 3.03597 19.0201 4.90797C19.9411 5.82472 20.6709 6.91515 21.1673 8.11606C21.6638 9.31698 21.917 10.6045 21.9121 11.9039C21.9361 17.3519 17.4961 21.7799 12.0481 21.7799ZM17.4721 14.3879C17.1721 14.2439 15.7081 13.5239 15.4441 13.4159C15.1681 13.3199 14.9761 13.2719 14.7721 13.5599C14.5681 13.8599 14.0041 14.5319 13.8361 14.7239C13.6681 14.9279 13.4881 14.9519 13.1881 14.7959C12.8881 14.6519 11.9281 14.3279 10.8001 13.3199C9.91209 12.5279 9.32415 11.5559 9.14415 11.2559C8.97616 10.9559 9.12015 10.7999 9.27615 10.6439C9.40815 10.5119 9.57615 10.2959 9.72009 10.1279C9.86409 9.95995 9.92409 9.82795 10.0201 9.63595C10.1161 9.43195 10.0681 9.26395 9.99609 9.11995C9.92409 8.97595 9.32415 7.51196 9.08416 6.91196C8.84416 6.33596 8.59216 6.40796 8.41216 6.39596H7.83616C7.63216 6.39596 7.32016 6.46796 7.04416 6.76796C6.78016 7.06796 6.01216 7.78796 6.01216 9.25195C6.01216 10.7159 7.08016 12.1319 7.22416 12.3239C7.36816 12.5279 9.32415 15.5279 12.3001 16.8119C13.0081 17.1239 13.5601 17.3039 13.9921 17.4359C14.7001 17.6639 15.3481 17.6279 15.8641 17.5559C16.4401 17.4719 17.6281 16.8359 17.8681 16.1399C18.1201 15.4439 18.1201 14.8559 18.0361 14.7239C17.9521 14.5919 17.7721 14.5319 17.4721 14.3879Z" fill="#121212"/>
            </svg>
          </a>
          <button onClick={(e) => { e.preventDefault(); copyToClipboard(); }} className="copy-link" title="Copy link">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18.5265 15.999H19.9999C21.0604 15.9977 22.0773 15.5761 22.8275 14.8265C23.5778 14.077 24.0002 13.0605 24.0025 12V4.0044C24.0012 2.94323 23.5791 1.92589 22.8287 1.17554C22.0784 0.425181 21.061 0.00307235 19.9999 0.00180054H12.0043C10.9432 0.00307235 9.92573 0.425181 9.17543 1.17554C8.42507 1.92589 8.00296 2.94323 8.00169 4.0044V5.3314C8.00169 5.68494 8.14213 6.02399 8.39212 6.27398C8.64211 6.52396 8.98116 6.6644 9.33469 6.6644C9.68817 6.6644 10.0272 6.52396 10.2773 6.27398C10.5272 6.02399 10.6677 5.68494 10.6677 5.3314V4.0044C10.6681 3.65001 10.8089 3.31022 11.0596 3.05964C11.3101 2.80904 11.6499 2.66811 12.0043 2.6678H19.9999C20.3536 2.66907 20.6926 2.81041 20.9424 3.0609C21.1922 3.31138 21.3325 3.65063 21.3329 4.0044V12C21.3319 12.3532 21.1912 12.6917 20.9414 12.9415C20.6916 13.1913 20.3531 13.332 19.9999 13.333H18.5265C18.1729 13.333 17.8339 13.4735 17.5839 13.7234C17.3339 13.9735 17.1935 14.3124 17.1935 14.666C17.1935 15.0196 17.3339 15.3585 17.5839 15.6086C17.8339 15.8585 18.1729 15.999 18.5265 15.999ZM4.0051 23.9982H12.0007C13.0612 23.9969 14.0781 23.5753 14.8283 22.8257C15.5786 22.0761 16.001 21.0597 16.0033 19.9992V12.0036C16.002 10.9425 15.5799 9.92503 14.8295 9.17473C14.0792 8.42437 13.0618 8.00226 12.0007 8.00099H4.0051C2.94393 8.00226 1.92659 8.42437 1.17624 9.17473C0.425883 9.92503 0.00377425 10.9425 0.00250244 12.0036V19.9992C0.00472211 21.0597 0.427251 22.0761 1.17751 22.8257C1.92776 23.5753 2.94456 23.9969 4.0051 23.9982ZM3.06034 11.0589C3.31092 10.8082 3.65071 10.6674 4.0051 10.667H12.0007C12.3544 10.6682 12.6934 10.8097 12.9432 11.0601C13.193 11.3106 13.3333 11.6498 13.3337 12.0036V19.9992C13.3331 20.3528 13.1925 20.6917 12.9427 20.9419C12.693 21.1922 12.3543 21.3333 12.0007 21.3346H4.0039C3.64993 21.334 3.31063 21.193 3.06033 20.9427C2.81003 20.6925 2.66914 20.3531 2.6685 19.9992V12.0036C2.66881 11.6492 2.80975 11.3094 3.06034 11.0589Z" fill="#121212"/>
            </svg>
          </button>
        </div>
        <button className="close-button" onClick={() => setShowShareModal(false)}>
          Close
        </button>
      </div>
    </div>
  );

  if (showComponent) {
    return (
      <div className="App" style={{ padding: '20px' }}>
        <div className="container-pop">
        <HeaderWithClose showClose={showComponent !== 'results'} />
        {showComponent === 'constituency' && <ConstituencyWise />}
        {showComponent === 'region' && <RegionWiseResults />}
        {showComponent === 'results' && <div className="container-share"><TotalResult /></div>}
        <p className="copyright">© Copyright Mathrubhumi 2025. All rights reserved.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <div className="container-1 total-result">
        <button onClick={handleShare} className="share-button" aria-label="Share Bihar 2025 Results Total">
          <FaShare />
        </button>
        <TotalResult />
        <NavigationWithPopups />
      </div>
      <div className="container-1 container-2">
        <div className="container-4">
          <div className="container-4-i">
            <PartyResults title="NDA" />
            <PartyResults title="OTH" />
          </div>
          <PartyResults title="INDIA" />
        </div>
        <div className="container-2">
          <ElectionSlider />
        </div>
      </div>
      <div className="container-1 container-3 map-view">
        <MapView />
      </div>
      {showShareModal && renderShareModal()}
    </div>
  );
}

export default App;